import { createSlice } from "@reduxjs/toolkit";
import { stripeConnectAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const stripeConnectSlice = createSlice({
  name: "stripeConnect",
  initialState: data,
  reducers: {
   stripeConnectSlice(state) {
      state.isLoading = true;
    },
   stripeConnectSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    stripeConnectSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   stripeConnectSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const stripeConnectHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(stripeConnectAction.stripeConnectSlice());
    const response: any = await stripeConnectAPI(data);
    
    dispatch(stripeConnectAction.stripeConnectSliceSuccess(response));
  } catch (e: any) {
    dispatch(stripeConnectAction.stripeConnectSliceFailure(e?.response?.data));
  }
};
export default stripeConnectSlice.reducer;
export const stripeConnectAction = stripeConnectSlice.actions;
